// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"542":"1375feda","820":"fc747ac1"}[chunkId] + ".chunk.css";
};